module.exports = __webpack_public_path__ + "media/site_templates/www.localtilers.com.au/images/feature_3-0408db30eb13d520307f3e499ba923ea.jpeg";